import ApiService from '@/core/api/api.service';
import { VendorUserService } from '@/core/vendor-user';

import { functionsWithNotifications } from '@/core/notifications';
import accessRequestMessages from './access-request.messages';
import AccessRequest from './access-request.mapper';

const vendorApi = new ApiService();

const functions = {
  create,
};

export default {
  ...functionsWithNotifications(functions, accessRequestMessages),
};

async function create(vendorUuid, sentInvitationUuid) {
  const requestBody = sentInvitationUuid ? {
    access_request: {
      sent_invitation_uuid: sentInvitationUuid,
    },
  } : {};

  const params = {
    no_token_cache: true, // Required by the API to clear VM's user cache in order to prevent a possible 422 when requesting access
  };

  const response = await vendorApi.post(`vendors/${vendorUuid}/access_requests`, requestBody, { params });
  // Sending an access request may change the vendor user, so the cache needs to be cleared to re-fetch the updated value
  VendorUserService.clearCache();
  return new AccessRequest(response.data.data);
}
